import {
    fixValidEnd,
    customizeDictionaryString,
    attributeAnnotations,
    truncate,
    sortBy,
    groupBy,
    currencyFormatter,
    mergeAnnotations,
    aminoSequenceSplitted,
    getAminoAcidVariant,
    html,
} from "./utils";

import {
    direction,
    wordings,
    Selector,
    aminoSequenceColors,
    severityToClassName,
    EDITOR_TYPES, nomenclatures,
} from "../mixins/dictionaries";

export class AbstractTabs {
    constructor(initSettings) {
        this.settings = initSettings;
        this.sequenceLength = 0;

        this.hiddenAnnotations = [];
        this.hiddenRestrictionEnzymes = [];

        this.editorAnnotations = {
            annotations: []
        };

        this.areaViewSize = 0;

        this.protocolAnnotations = {
            context: {
                pk: null,
                type: null,
            },
            annotations: []
        };

        this.filtersOn = {
            "enzymes-list": '',
            "aminos-list": '',
            "others-list": '',
            "warnings-list": '',
            "fragments-list": '',
        }
        this.currencyFormatter = currencyFormatter(this.settings.currency)
    }

    addEventsTabs() {
        document
            .querySelectorAll('.search-in-tabs div input')
            .forEach((el) => {
                el.addEventListener('keyup', (e) => {
                    const searchInput = e.currentTarget;
                    const textToSearchFor = searchInput.value;
                    let itemListName = searchInput.dataset.list;
                    this.filterRowsTabs(itemListName, textToSearchFor)
                })
            });

        document.querySelectorAll('form.search-in-tabs').forEach((el) => {
            el.addEventListener('submit', (e) => {
                e.preventDefault();
            })
        });
    }

    setAnnotations(data) {
        this.annotations = mergeAnnotations(data, this.editorAnnotations, this.protocolAnnotations, this.sequenceLength, this.hiddenAnnotations, false);
    }

    addTableItems(rows, selector, listName, showSlotName = false) {
        let table = document.querySelector(selector);
        let listItems = document.createElement('ul');
        const order = selector === Selector.FRAGMENTS_TAB ? "sort_key" : "start";

        listItems.classList.add('list-group');
        listItems.classList.add(listName);

        const orderedList = rows.sort(sortBy(order));

        orderedList.forEach((row) => {
            const slotName = row.slot ? row.slot : "";
            const isChecked = row.visible ? "checked" : "";
            let listItemsDetail = "";

            let fromBp = row.start + 1;
            let toBp = row.end;

            const length = (fixValidEnd(fromBp, toBp, this.sequenceLength) - fromBp + 1);

            if (toBp > this.sequenceLength) {
                toBp = (row.end - this.sequenceLength)
            }
            const tmpStart = row.start;
            const tmpEnd = row.end < row.start ? row.end + this.sequenceLength : row.end;
            const attributeAnnotation = attributeAnnotations(row.role_id, this.settings.annotation_colors);
            const name = row.name ? row.name : "Unknown " + attributeAnnotation.name
            const type = attributeAnnotation.name
            const label = `${fromBp}..${toBp}`;
            let dataContent = html.escape(`${label} ${name} ${type} ${direction[row.direction]} ${slotName} ${fromBp} ${toBp} `);

            if (selector === Selector.CODING_SEQUENCES_TAB) {
                dataContent += row.amino_sequence;
            }

            let detailRow = `<li><strong>Type: </strong><span class="text-capitalize">${type}</span></li>`;
            detailRow += row.price ? `<li><strong>Price: </strong>${this.currencyFormatter.format(row.price)}</li>` : "";
            detailRow += row.melting_temp ? `<li><strong>Tm: </strong>${row.melting_temp.toFixed(2)}&deg;C</li>` : "";

            if (listName === 'fragments-list') {
                if (row.error_messages && row.error_messages.length) {
                    let errorsList = "<ul class='list-unstyled' data-start='" + tmpStart + "' data-end='" + tmpEnd + "'>";

                    row.error_messages.forEach(e => {
                        errorsList += "<li class='alert " + severityToClassName[e.severity] + "' >" + e.message + "</li>";
                    });
                    errorsList += "</ul>";
                    listItemsDetail = `<div class="mt-2 list-group errors" >${errorsList}</div>`;
                }
            }

            if (selector === Selector.CODING_SEQUENCES_TAB && this.settings.editorType === EDITOR_TYPES.libraries) {
                const aminoSequence = aminoSequenceSplitted(row.amino_sequence, row.direction);
                const $variance = document.createElement('div');
                $variance.classList.add("collapse", "list-group", "mt-2");
                $variance.id = "variants_" + row.pk;

                let startCodon = row.start
                let endCodon = startCodon + 3;

                aminoSequence.forEach((codon, i) => {
                    const variants = getAminoAcidVariant(row.variants, i);
                    const pos = row.direction === 2 ? (row.amino_sequence.length - i) : i + 1;
                    if (variants && this.settings.editorType === EDITOR_TYPES.libraries) {
                        const $variantAminoAcidsItem = document.createElement('div')
                        $variantAminoAcidsItem.classList.add("d-flex", "justify-content-between", "align-items-center", "list-group-item")

                        const $variantCodonContainer = document.createElement('div')
                        $variantCodonContainer.innerHTML = `${nomenclatures[codon]}${pos}<br><span class="opacity-50">${variants.scheme_name}</span>`

                        $variantAminoAcidsItem.appendChild($variantCodonContainer)

                        const $variantIconsContainer = document.createElement('div')
                        $variantIconsContainer.classList.add("btn-group", "btn-group-sm")

                        const $variantLinkGoTo = document.createElement('button')
                        $variantLinkGoTo.type = "button"
                        $variantLinkGoTo.classList.add("btn", "btn-secondary", "align-icon")
                        $variantLinkGoTo.dataset.start = startCodon
                        $variantLinkGoTo.dataset.end = endCodon

                        const $clickableLinkGoto = document.createElement('i')
                        $clickableLinkGoto.classList.add("material-symbols-outlined")
                        $clickableLinkGoto.innerText = "jump_to_element"

                        $variantLinkGoTo.appendChild($clickableLinkGoto)
                        $variantIconsContainer.appendChild($variantLinkGoTo)

                        const $variantDetail = document.createElement('button')
                        $variantDetail.type = "button"
                        $variantDetail.classList.add("btn", "btn-secondary", "align-icon")
                        $variantDetail.dataset.start = startCodon
                        $variantDetail.dataset.urlVariant = variants.urls.view


                        $variantDetail.innerText = "View"
                        $variantIconsContainer.appendChild($variantDetail)

                        $variantAminoAcidsItem.appendChild($variantIconsContainer)

                        $variance.appendChild($variantAminoAcidsItem)


                    }
                    startCodon += 3
                    endCodon += 3;
                })
                listItemsDetail = `<div class="mt-2 list-group" >${$variance.outerHTML}</div>`;
            }

            let itemList = document.createElement('li');
            itemList.classList.add('list-group-item', 'list-group-item-action');
            itemList.dataset.start = tmpStart;
            itemList.dataset.end = tmpEnd;

            itemList.innerHTML = `
            <div class="d-flex align-items-center justify-content-between item" 
                data-content="${dataContent}">
                <div class="d-flex d-inline-flex me-2">
                    <div class="d-flex form-check p2 align-items-center">
                        <input type="checkbox" class="form-check-input item${row.pk}" id="${row.pk}" data-pk="${row.pk}" ${isChecked}>
                        <label class="form-check-label visually-hidden" for="${row.pk}">Show/hide</label>
                    </div>                    
                    <ul class="list-unstyled z-index-0 p-0" data-start="${tmpStart}" data-end="${tmpEnd}">
                        <li><strong>Name: </strong>${name}</li>                            
                        ${detailRow}                      
                        <li><strong>Direction: </strong>${direction[row.direction]}</li>
                        ${row.hasOwnProperty('slot') ? `<li><strong>Slot: </strong>${truncate(slotName, 40)}</li>` : ``}
                        <li><strong>Length: </strong>${length} Bp</li>
                        ${this.settings.editorType === EDITOR_TYPES.libraries && row.variants?.length ? `<li class="mt-1"><a class="link-primary text-decoration-underline" data-variant-card data-bs-toggle="collapse" href="#variants_${row.pk}" role="button" aria-expanded="false" aria-controls="collapse"># Variants: <span class="fw-medium">${row.variants.length}</span></a></li>` : ``}
                    </ul>
                </div>                
                <a class="d-flex align-items-center link-primary" data-start="${tmpStart}" data-end="${tmpEnd}" href="#"><u>${label}</u></a>                                                                                                     
            </div>
            ${listItemsDetail}`;

            if (listName !== 'fragments-list' || (listName === 'fragments-list' && row.deliverable)) {
                listItems.appendChild(itemList);
            }
        })
        table.appendChild(listItems);
    }

    drawRestrictionEnzymes(rows) {
        this.resetTabs(Selector.REST_ENZYMES_TAB, 'enzymes-list');

        if (!rows.length) {
            this.noRows(Selector.REST_ENZYMES_TAB, customizeDictionaryString(wordings["no_items"], "restriction enzyme sites"));
        } else {
            const restEnzymeGroupedBy = groupBy(rows, "name");
            let tableRestEnzymes = document.querySelector(Selector.REST_ENZYMES_TAB);

            let listItemsContainer = document.createElement('ul');
            listItemsContainer.classList.add('list-group');
            listItemsContainer.classList.add('enzymes-list');

            for (const [key] of Object.entries(restEnzymeGroupedBy)) {
                let cutEnzyme = '';
                let rowEnzyme = 're_' + key;

                for (let y = 0; y < restEnzymeGroupedBy[key].length; y++) {
                    let row_cut_id = "cut_" + key + "_" + y;
                    let endRe = restEnzymeGroupedBy[key][y].end < restEnzymeGroupedBy[key][y].start && restEnzymeGroupedBy[key][y].start - restEnzymeGroupedBy[key][y].end > 100 ?
                        restEnzymeGroupedBy[key][y].end + this.sequenceLength :
                        restEnzymeGroupedBy[key][y].end;
                    const dataContent = html.escape(`${key} ${restEnzymeGroupedBy[key][0].hang} ${restEnzymeGroupedBy[key][0].site} ${restEnzymeGroupedBy[key][y].start} ${restEnzymeGroupedBy[key][y].end} ${restEnzymeGroupedBy[key][y].cut_5}`)
                    cutEnzyme += `<div class="list-group-item list-group-item-action list-group-item-secondary item" 
                        data-content="${dataContent}" >						
						<div class="form-check me-sm-2" data-start="${restEnzymeGroupedBy[key][y].start}" data-end="${endRe}">
							<input type="checkbox" class="form-check-input" data-pk="${restEnzymeGroupedBy[key][y].id}" data-group="" id="${row_cut_id}" ${(restEnzymeGroupedBy[key][0].visible ? 'checked' : '')}>
							<label class="form-check-label" for="${row_cut_id}">After bp ${restEnzymeGroupedBy[key][y].cut_5}</label>
							<a class="float-end" href="#"><i class="material-symbols-outlined" data-start="${restEnzymeGroupedBy[key][y].start}" data-end="${endRe}">jump_to_element</i></a>
						</div>																					
					</div>`;
                }

                let itemList = document.createElement('li');
                itemList.classList.add('list-group-item');
                itemList.classList.add('list-group-item-action');
                itemList.classList.add('enzyme');
                itemList.innerHTML = `<div class="d-flex align-items-center justify-content-between">
						<div class="d-flex">
							<div class="form-check me-sm-2">
								<input type="checkbox" class="form-check-input cuts" id="${rowEnzyme}" data-group="RE_${key}" checked>
								<label class="form-check-label visually-hidden" for="${rowEnzyme}">Show/hide</label>
							</div>
							<ul class="list-unstyled">
								<li><strong>Name: </strong><span>${key}</span></li>
								<li><strong>Hangs: </strong>${restEnzymeGroupedBy[key][0].hang}</li>
								<li>
									<a class="link-primary" data-bs-toggle="collapse" href="#RE_${key}" role="button" aria-expanded="false" aria-controls="collapse">
										# Cuts: ${restEnzymeGroupedBy[key].length}
									</a>
								</li>
							</ul>
						</div>
						<span>${restEnzymeGroupedBy[key][0].site}</span>
					</div>
					<div class="collapse mt-2" id="RE_${key}">
						<div class="list-group">
							${cutEnzyme}
						</div>
					</div>`;

                listItemsContainer.appendChild(itemList);
            }
            tableRestEnzymes.appendChild(listItemsContainer);
        }
    }

    toggleItems(checkBoxItems, content, status) {
        const idItems = [];
        checkBoxItems.forEach(c => {
            if (c.dataset.pk) {
                idItems.push(parseInt(c.dataset.pk));
            }
            c.checked = status;
        });

        /**
         *  subCheckBoxes in Restriction Enzymes
         */
        if (idItems.length === 0) {
            const subCheckBoxItems = document.querySelectorAll(`.${content} li.list-group-item:not(.d-none) .row input[type='checkbox']`);
            subCheckBoxItems.forEach(c => {
                idItems.push(c.dataset.pk);
                c.checked = status;
            })
        }
        return idItems;
    }

    resetTabs(tabs, itemClass) {
        this.removeTabItems(tabs, itemClass);
        this.showTabTools(tabs);
    }

    removeTabItems(tabs, itemClass) {
        const tabItems = document.querySelectorAll(`${tabs} .${itemClass}, ${tabs} .no-rows`);
        tabItems.forEach(el => {
            el.parentNode.removeChild(el)
        });
    }

    showTabTools(tabs) {
        const containers = document.querySelectorAll(`${tabs} > .search-in-tabs, ${tabs} > div`);
        containers.forEach(el => {
            el.style.display = 'block';
        });
    }

    filterRowsTabs(itemListName, textToSearchFor) {
        const totalItems = document
            .querySelector("." + itemListName)
            .closest("div")
            .querySelector('ul');

        const totalVisibleItems = totalItems
            .querySelectorAll('li.list-group-item.list-group-item-action:not(.no-result)')
            .length;

        document
            .querySelectorAll("ul." + itemListName + ' .item')
            .forEach((e) => {
                const mainItem = e.closest('li.list-group-item');
                const cleanedTextToSearchFor = textToSearchFor.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
                const regExpCleanedTextToSearchFor = new RegExp(cleanedTextToSearchFor, "i");
                let affectedItem = false;

                if (regExpCleanedTextToSearchFor.test(e.dataset.content) && textToSearchFor !== null) {
                    affectedItem = true
                }

                if (affectedItem) {
                    mainItem.classList.remove('d-none')
                } else {
                    mainItem.classList.add('d-none')
                }
            });

        this.filtersOn[itemListName] = textToSearchFor;

        const totalHiddenItems = totalItems
            .querySelectorAll('li.d-none')
            .length;

        const itemNotResult = totalItems
            .querySelectorAll('li.no-result');

        if (itemNotResult.length) {
            totalItems
                .removeChild(itemNotResult[0]);
        }

        if (totalHiddenItems >= totalVisibleItems) {
            this.noResult(itemListName);
        }

        const filterNotification = document.querySelector(`a#${itemListName}-tab > i > span`);
        if (textToSearchFor.length) {
            filterNotification.classList.remove('d-none')
        } else {
            filterNotification.classList.add('d-none')
        }

    }

    noRows(tab, text) {
        const tabTools = document.querySelectorAll(`${tab} > .search-in-tabs, ${tab} > div`);

        tabTools.forEach(el => {
            el.style.display = "none";
        })

        const noRowsContainer = document.createElement(`div`);
        noRowsContainer.classList.add('h-100', 'mt-3', 'p-5', 'text-bg-secondary', 'rounded-3', 'text-center', 'no-rows')
        noRowsContainer.innerText = text;

        const container = document.querySelector(`${tab}`);
        container.appendChild(noRowsContainer);
    }

    noResult(itemListName) {
        const item = document.createElement('li');
        item.className = 'list-group-item list-group-item-action no-result m-0 p-0';
        item.innerHTML = "<div class='h-100 p-5 text-bg-secondary rounded-3 text-center mt-1'>No results found</div>";

        document
            .querySelector("ul." + itemListName + ' li')
            .closest("ul")
            .appendChild(item);
    }
}

